import React, { FC } from 'react'
import styles from 'styles/components/calendar.module.scss'
import getDate from 'date-fns/getDate'
import isSameDay from 'date-fns/isSameDay'
import isSameMonth from 'date-fns/isSameMonth'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { getStoreCurrentMonth } from 'reducks/storeCalendar/selectors'

type Props = {
  date: Date
  isActive: boolean
  isRegularClosed: boolean
  isOrdered: boolean
  isSpecialHoliday: boolean
  isTemporaryClosed: boolean
  isTemporaryOpen: boolean
  selectDate: (date: Date | undefined) => void
}

const OpenStoreCalendarCell: FC<Props> = React.memo((props) => {
  const {
    date,
    isActive,
    isRegularClosed,
    isOrdered,
    isSpecialHoliday,
    isTemporaryClosed,
    isTemporaryOpen,
    selectDate,
  } = props

  const currentMonth = useSelector((state: State) => getStoreCurrentMonth(state))
  const isThisMonth = isSameMonth(date, currentMonth)

  const className = (() => {
    switch (true) {
      case isThisMonth && isActive:
        return styles.table__cell_set
      // 臨時営業日の場合
      case isThisMonth && isTemporaryOpen && !isTemporaryClosed:
        return styles.table__cell_open
      // 臨時休業日の場合（灰色セル）
      case isThisMonth && isTemporaryClosed && !isTemporaryOpen:
        return styles.table__cell_closed
      // 定休日の場合（灰色セル）
      case isThisMonth && isRegularClosed && isSpecialHoliday:
        return styles.table__cell__holiday_disabled
      // 定休日の場合（灰色セル）
      case isThisMonth && isRegularClosed:
        return styles.table__cell_disabled
      // 当日が祝日
      case isThisMonth && isSameDay(date, new Date()) && isSpecialHoliday:
        return styles.table__cell__holiday_today
      // 当日
      case isThisMonth && isSameDay(date, new Date()):
        return styles.table__cell_today
      // 祝日
      case isThisMonth && isSpecialHoliday:
        return styles.table__cell__holiday
      default:
        return styles.table__cell
    }
  })()

  // タップ/クリックされたときの処理
  const onClick = () => {
    switch (true) {
      case !isThisMonth:
        return null
      case isActive:
        return selectDate(undefined)
      default:
        return selectDate(date)
    }
  }

  return (
    <td className={className} onClick={() => onClick()}>
      <span className={styles.table__cell__date}>
        {isThisMonth ? getDate(date) : ''}
        {isThisMonth && isOrdered && <span className={styles.table__mark} />}
      </span>
    </td>
  )
})

export default OpenStoreCalendarCell
